import * as React from 'react';

import { getLocale } from '@rematter/common/locale';
import { FooterItem, MeasuredValue, Money } from '@rematter/ui-web';

import { useBrokeredLoadLineItemsTotals } from '~/modules/brokerage/hooks/useBrokeredLoadLineItemsTotals';
import { useTranslations } from '~/modules/brokerage/i18n/useTranslations';
import { BrokeredLoadFormLineItem } from '~/modules/brokerage/types/brokeredLoad';
import { WeightUnitType } from '~/modules/trade/types/load';

type Props = {
  lineItems: BrokeredLoadFormLineItem[];
  weightUnit?: WeightUnitType;
};

export const LoadRequestedMaterialsFooter: React.FC<Props> = ({
  lineItems,
  weightUnit,
}) => {
  const t = useTranslations();

  const { materialCount, totalNet, totalValue, currencyCode, displayUnit } =
    useBrokeredLoadLineItemsTotals(lineItems, weightUnit);

  return (
    <>
      <FooterItem label={t.brokerage.loads.detail.materials.columns.material}>
        <span className="text-lg font-bold tracking-tight">
          {materialCount}
        </span>
      </FooterItem>
      <div className="h-9 w-px bg-neutral/10" />

      <FooterItem label={t.brokerage.loads.detail.materials.totalNet}>
        <div className="text-lg font-bold">
          <MeasuredValue
            value={totalNet?.value ?? 0}
            unit={totalNet?.unit ?? displayUnit}
          />
        </div>
      </FooterItem>

      <div className="h-9 w-px bg-neutral/10" />

      <FooterItem label={t.brokerage.loads.detail.materials.totalValue}>
        <div className="text-lg font-semibold">
          <Money
            amount={totalValue}
            currencyCode={currencyCode}
            locale={getLocale()}
          />
        </div>
      </FooterItem>
    </>
  );
};
